import { StyleSheet, Text, View } from '@react-pdf/renderer'

export const defaultFormPdfFontFamily = 'Open Sans'
export const inuktitutFormPdfFontFamily = 'Pigiarniq'
export const pdfDefaultFontSize = 10
/**
 * Minimal space (pt) left on a page that a form element value or a table row needs to start there,
 * otherwise it's moved to the next page. Roughly fits two lines of a table cell with padding.
 */
export const PDF_VALUE_MIN_PRESENCE_AHEAD = 40

export const commonPDFStyles = StyleSheet.create({
  sectionTitle: {
    fontSize: 12,
    color: '#17474f',
    paddingBottom: 16,
    fontWeight: 'bold'
  },
  elementTitle: {
    padding: 10,
    fontSize: 16,
    fontWeight: 400
  },
  pdfTitle: {
    paddingBottom: 16,
    fontWeight: 'bold',
    fontSize: 18,
    color: '#17474f'
  },
  row: {
    flexWrap: 'nowrap',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    border: '1px solid black',
    borderCollapse: 'collapse'
  },
  bullet: {
    width: 4,
    height: 4,
    borderRadius: 3,
    color: '#000000',
    backgroundColor: '#000000',
    marginRight: 8,
    marginTop: 4,
    flexShrink: 0
  }
})

export const PDFPageNumber = (): React.ReactElement => {
  return (
    <View
      fixed
      style={{
        position: 'absolute',
        bottom: '1.27cm',
        width: '15.92cm',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      render={({ pageNumber, totalPages }) => (
        <Text>{String(pageNumber) + '/' + String(totalPages)}</Text>
      )}
    />
  )
}
